module.exports = __webpack_public_path__ + "img/fulham-fc.08f5bb7b.png";